import { RandomActivityGenerator } from './activityGenerator'
import { EsLog } from './log'

const log = new EsLog(new RandomActivityGenerator(['push-up', 'sit-up'], { min: 60, max: 120 }))

export default log
